/* app/js/src/components/common/progressbar/progressbar.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host .bar {
  height: 6px;
  background: #dde3e7;
  box-shadow: inset 0.7px 0.7px 5px 0 rgba(0, 0, 0, 0.05);
  position: relative;
}
:host .progress {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  border-bottom-right-radius: 3px;
  border-top-right-radius: 3px;
  -webkit-transition: width 0.3s cubic-bezier(0.6, 0.04, 0.54, 0.99);
  transition: width 0.3s cubic-bezier(0.6, 0.04, 0.54, 0.99);
}
:host.small .bar {
  height: 3px;
}
:host.flat .progress {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}
.theme-purple .progress {
  background-color: #a65bfa;
}
.theme-cyan .progress {
  background-color: #40c4ff;
}
.theme-red .progress {
  background-color: #ef5350;
}
.theme-green .progress {
  background-color: #61b965;
}
/*# sourceMappingURL=progressbar.component.css.map */
